import http from "../http-common"

const getAll = () => {
    return http.get(`/lastCard`)
}

const get = id => {
    return http.get(`/lastCard/${id}`)
}

const create = data => {
    return http.post("/lastCard", data)
}

const update = (id, data) => {
    return http.put(`/lastCard/${id}`, data)
}

const remove = id => {
    return http.delete(`/lastCard/${id}`)
}

const removeAll = () => {
    return http.delete(`/lastCard`)
}

export default {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
}
